export default function isNodeServer() {
  return !!window.__getComponentInNode;
}
